import {apiUrlNew} from "./global";

function createStaticURL(file_id) {
    return apiUrlNew + "/static_file/" + file_id;
}

export default createStaticURL;
